"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _reactDatepicker = require("react-datepicker");

var _ptBR = _interopRequireDefault(require("date-fns/locale/pt-BR"));

var _ = require("../");

var _styles = _interopRequireDefault(require("./styles"));

var _timePickerStyles = _interopRequireDefault(require("./timePickerStyles"));

var _excluded = ["label", "selected", "onChange", "name", "interval"];
var Datepicker = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var label = _ref.label,
      selected = _ref.selected,
      _onChange = _ref.onChange,
      name = _ref.name,
      interval = _ref.interval,
      rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  (0, _reactDatepicker.registerLocale)('ptBR', _ptBR.default);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_timePickerStyles.default, null), /*#__PURE__*/_react.default.createElement(_styles.default, Object.assign({
    ref: ref,
    name: name,
    shouldCloseOnSelect: false,
    customInput: /*#__PURE__*/_react.default.createElement(_.Input, {
      label: label,
      rightIcon: /*#__PURE__*/_react.default.createElement(_.Icon, {
        name: "time-clock-circle",
        width: "24",
        height: "24"
      })
    }),
    locale: "ptBR",
    timeIntervals: interval,
    selected: selected,
    onChange: function onChange(e) {
      _onChange === null || _onChange === void 0 ? void 0 : _onChange(e);
    }
  }, rest)));
});
Datepicker.defaultProps = {
  interval: 60
};
var _default = Datepicker;
exports.default = _default;